package com.essntl.features.contact.data.supabase

import com.essntl.features.contact.domain.model.ContactModel
import core.dateformat.utils.fromDDTOMM
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun ContactModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    firstName?.let {
        requestMap["first_name"] = JsonPrimitive(it)
    }

    lastName?.let {
        requestMap["last_name"] = JsonPrimitive(it)
    }

    email?.let {
        requestMap["email"] = JsonPrimitive(it)
    }

    phoneNumber?.let {
        requestMap["phone_number"] = JsonPrimitive(it)
    }

    address?.id?.let { id ->
        requestMap["address_id"] = JsonPrimitive(id)
    }

    notes?.let {
        requestMap["notes"] = JsonPrimitive(it)
    }

    organization?.id?.let { id ->
        requestMap["organization_id"] = JsonPrimitive(id)
    }

    salutation?.let {
        requestMap["salutation"] = JsonPrimitive(it)
    }

    dateOfBirth?.let {
        requestMap["date_of_birth"] = JsonPrimitive(fromDDTOMM(it))
    }

    return requestMap
}